import { render, staticRenderFns } from "./OriginalImages.vue?vue&type=template&id=67bd0cb1"
import script from "./OriginalImages.vue?vue&type=script&lang=js"
export * from "./OriginalImages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports